/**
 * The Complete Wet Shaving Starter Kit — selection engine + add-to-cart.
 * All catalog data (variant ids, prices, availability) is read from server-rendered
 * data attributes; nothing is hardcoded here. The cart flow mirrors the theme's own
 * product form: /cart/add.js -> /cart.js -> cartUpdate pubsub -> cart drawer opens.
 */
(function () {
  'use strict';

  var TOKEN = 'wet-shaving-starter-kit';
  var KIT_LABEL = 'The Complete Wet Shaving Starter Kit';
  var state = { scent: 'sandalwood', finish: 'classic' };
  var addingKit = false;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var whole = String(Math.round(cents / 100));
    var out = fmt
      .replace(/\{\{amount\}\}/g, value)
      .replace(/\{\{amount_no_decimals\}\}/g, whole)
      .replace(/\{\{amount_with_comma_separator\}\}/g, value.replace('.', ','))
      .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g, whole);
    // The store's money format wraps amounts in HTML; these strings are written as
    // textContent, so strip any markup and keep the plain amount.
    return out.replace(/<[^>]*>/g, '').trim();
  }
  function moneyShort(cents) {
    var m = money(cents);
    return cents % 100 === 0 ? m.replace(/\.00$/, '') : m;
  }

  /* ---------- selection ---------- */
  function cards() { return $$('[data-fudge-kit-card]'); }

  function cardMatches(card) {
    var scents = (card.getAttribute('data-scent') || 'all').split(' ');
    if (scents.indexOf('all') === -1 && scents.indexOf(state.scent) === -1) return false;
    var finish = card.getAttribute('data-finish');
    if (finish && finish !== state.finish) return false;
    return true;
  }
  function kitCards() { return cards().filter(cardMatches); }

  function refreshCards() {
    cards().forEach(function (card) {
      if (cardMatches(card)) {
        card.removeAttribute('hidden');
        card.style.animation = 'none';
        void card.offsetHeight;
        card.style.animation = '';
      } else {
        card.setAttribute('hidden', '');
      }
    });
  }

  function refreshPills() {
    $$('[data-fudge-kit-scent]').forEach(function (pill) {
      var active = pill.getAttribute('data-fudge-kit-scent') === state.scent;
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    $$('[data-fudge-kit-finish]').forEach(function (pill) {
      var active = pill.getAttribute('data-fudge-kit-finish') === state.finish;
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var scentLabels = { sandalwood: 'Sandalwood', barbershop: 'Barbershop', 'bay-rum': 'Bay Rum' };
    var finishLabels = { classic: 'Baron Classic (Brushed Alloy)', noir: 'Baron Elite (Noir Black)', noble: 'Baron Noble (Forge Gray)' };
    var finishShort = { classic: 'Baron Classic', noir: 'Baron Elite', noble: 'Baron Noble' };
    $$('[data-kit-selected-scent]').forEach(function (el) { el.textContent = scentLabels[state.scent] || state.scent; });
    $$('[data-kit-selected-finish]').forEach(function (el) { el.textContent = finishLabels[state.finish] || state.finish; });
    $$('[data-kit-selected-finish-short]').forEach(function (el) { el.textContent = finishShort[state.finish] || state.finish; });
  }

  function kitPriceCents() {
    var el = $('[data-kit-price-cents]');
    return el ? parseInt(el.getAttribute('data-kit-price-cents'), 10) || 0 : 0;
  }

  function showKitError(message) {
    $$('[data-fudge-kit-error]').forEach(function (el) {
      el.textContent = message;
      el.classList.add('is-visible');
    });
  }
  function clearKitError() {
    $$('[data-fudge-kit-error]').forEach(function (el) { el.classList.remove('is-visible'); });
  }

  function recompute() {
    var parts = kitCards();
    var separate = parts.reduce(function (sum, card) {
      return sum + (parseInt(card.getAttribute('data-price'), 10) || 0);
    }, 0);
    var kit = kitPriceCents();
    var save = Math.max(separate - kit, 0);
    var percent = separate > 0 ? Math.round((save / separate) * 100) : 0;
    $$('[data-kit-separate]').forEach(function (el) { el.textContent = money(separate); });
    $$('[data-kit-save]').forEach(function (el) { el.textContent = moneyShort(save); });
    $$('[data-kit-save-percent]').forEach(function (el) { el.textContent = String(percent); });

    var soldOut = parts.some(function (card) { return card.getAttribute('data-available') === 'false'; });
    $$('[data-fudge-kit-add]').forEach(function (btn) {
      if (addingKit) return;
      btn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
    });
    if (soldOut) showKitError("One of the kit pieces is sold out right now — write to us and we'll tell you the moment it's back.");
    else clearKitError();
  }

  /* ---------- cart (mirrors the theme's product form) ---------- */
  function routes() {
    return (window.theme && theme.routes) || { cart_add_url: '/cart/add', cart_url: '/cart' };
  }

  function addToCart(items) {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));
    var r = routes();
    return fetch(r.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sectionsToBundle.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (parsed) {
          if (!response.ok || parsed.status) {
            throw new Error(parsed.description || parsed.message || 'Could not add to cart.');
          }
          return parsed;
        });
      })
      .then(function (parsed) {
        return fetch(r.cart_url + '.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            cart.sections = parsed.sections;
            if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cart: cart });
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsed } }));
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') {
              drawer.show();
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            }
          });
      });
  }

  function kitItems() {
    return kitCards().map(function (card) {
      return {
        id: parseInt(card.getAttribute('data-variant-id'), 10),
        quantity: 1,
        properties: {
          _fudge: JSON.stringify({ offer: TOKEN, slot: card.getAttribute('data-slot') }),
          'Starter Kit': KIT_LABEL
        }
      };
    });
  }

  function handleKitAdd() {
    if (addingKit) return;
    var parts = kitCards();
    if (!parts.length) return;
    var soldOut = parts.some(function (card) { return card.getAttribute('data-available') === 'false'; });
    if (soldOut) { recompute(); return; }

    addingKit = true;
    var buttons = $$('[data-fudge-kit-add]');
    buttons.forEach(function (btn) {
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
    });

    addToCart(kitItems())
      .then(
        function () { clearKitError(); },
        function (error) { showKitError((error && error.message) || 'Could not add to cart.'); }
      )
      .then(function () {
        addingKit = false;
        buttons.forEach(function (btn) {
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('aria-disabled');
        });
        recompute();
      });
  }

  function normalizeAddonButton(button) {
    var available = button.getAttribute('data-available') !== 'false';
    var textEl = button.querySelector('.btn-text');
    if (!textEl) return;
    if (available) {
      var price = button.getAttribute('data-price-plain');
      textEl.textContent = price ? 'Add \u2014 ' + price : 'Add';
      button.removeAttribute('aria-disabled');
    } else {
      textEl.textContent = 'Sold out';
      button.setAttribute('aria-disabled', 'true');
    }
  }

  function handleAddonAdd(button) {
    if (button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-busy') === 'true') return;
    var id = parseInt(button.getAttribute('data-variant-id'), 10);
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    addToCart([{ id: id, quantity: 1 }])
      .then(
        function () { clearKitError(); },
        function (error) { showKitError((error && error.message) || 'Could not add to cart.'); }
      )
      .then(function () {
        button.removeAttribute('aria-busy');
        button.removeAttribute('aria-disabled');
      });
  }

  function handleColor(pill) {
    var card = pill.closest('[data-fudge-kit-addon]');
    if (!card) return;
    $$('[data-fudge-kit-color]', card).forEach(function (p) {
      var active = p === pill;
      p.classList.toggle('is-active', active);
      p.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var variantId = pill.getAttribute('data-variant-id');
    var addBtn = $('[data-fudge-kit-addon-add]', card);
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', variantId);
      addBtn.setAttribute('data-available', pill.getAttribute('data-available'));
    }
    var priceEl = $('[data-fudge-kit-addon-price]', card);
    if (priceEl) priceEl.textContent = pill.getAttribute('data-price') || '';
    $$('[data-addon-variant]', card).forEach(function (el) {
      if (el.getAttribute('data-addon-variant') === String(variantId)) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  /* ---------- sticky mobile bar ---------- */
  function initStickyBar() {
    var bar = $('[data-fudge-kit-stickybar]');
    if (!bar) return;
    var heroCta = $('.fudge-kit-hero .fudge-kit-atc');
    var ctas = $$('[data-fudge-kit-add]').filter(function (el) {
      return !el.closest('[data-fudge-kit-stickybar]');
    });
    var footer = document.querySelector('.footer-group');
    if (!heroCta) return;

    function check() {
      var heroRect = heroCta.getBoundingClientRect();
      var pastHero = heroRect.bottom < 0;

      var ctaInView = ctas.some(function (cta) {
        var r = cta.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      });

      var footerInView = false;
      if (footer) {
        var fRect = footer.getBoundingClientRect();
        footerInView = fRect.top < window.innerHeight;
      }

      var show = pastHero && !ctaInView && !footerInView;
      bar.classList.toggle('is-visible', show);
      if (show) bar.removeAttribute('hidden');
      else bar.setAttribute('hidden', '');
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          check();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  }

  /* ---------- init ---------- */
  function init() {
    refreshPills();
    refreshCards();
    recompute();
    $$('[data-fudge-kit-addon-add]').forEach(normalizeAddonButton);

    document.addEventListener('click', function (event) {
      var el = event.target && event.target.closest
        ? event.target.closest('[data-fudge-kit-scent], [data-fudge-kit-finish], [data-fudge-kit-add], [data-fudge-kit-addon-add], [data-fudge-kit-color]')
        : null;
      if (!el) return;
      if (el.hasAttribute('data-fudge-kit-scent')) {
        state.scent = el.getAttribute('data-fudge-kit-scent');
        refreshPills(); refreshCards(); recompute();
      } else if (el.hasAttribute('data-fudge-kit-finish')) {
        state.finish = el.getAttribute('data-fudge-kit-finish');
        refreshPills(); refreshCards(); recompute();
      } else if (el.hasAttribute('data-fudge-kit-add')) {
        handleKitAdd();
      } else if (el.hasAttribute('data-fudge-kit-addon-add')) {
        handleAddonAdd(el);
      } else if (el.hasAttribute('data-fudge-kit-color')) {
        handleColor(el);
      }
    });

    initStickyBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
